import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, CheckoutConfigSlice, CheckoutConfigData } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
  data?: CheckoutConfigData
}

const getSlice = (slice: CheckoutConfigSlice): CheckoutConfigSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false,
    data: undefined
  })
}

const slice = createSlice({
  name: 'quote/checkoutConfig',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = true
      state[cartId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartId, data } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
      slice.data = data
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchCheckoutConfig (cartId: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ cartId }))
    try {
      const response = await magentoClient.getClient().quote.fetchCheckoutConfig({ cartId })
      const { data } = response
      const { getCheckoutConfig } = data
      if (getCheckoutConfig) {
        dispatch(success({ cartId, data: getCheckoutConfig }))
      } else {
        dispatch(failure({ cartId }))
      }
      return response
    } catch (e) {
      dispatch(failure({ cartId }))
    }
  }
}
